import { render, staticRenderFns } from "./ViewEmployees.vue?vue&type=template&id=076bde18&scoped=true&"
import script from "./ViewEmployees.vue?vue&type=script&lang=ts&"
export * from "./ViewEmployees.vue?vue&type=script&lang=ts&"
import style0 from "./ViewEmployees.vue?vue&type=style&index=0&id=076bde18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076bde18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
